import { useState, useEffect } from 'react'

const STORAGE_KEY = 'webinternal-dark-mode'

function getInitialDark() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored !== null) return stored === 'true'
  } catch (_) {}
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

export function useDarkMode() {
  const [dark, setDark] = useState(getInitialDark)

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark)
    try {
      localStorage.setItem(STORAGE_KEY, String(dark))
    } catch (_) {}
  }, [dark])

  return [dark, setDark]
}
